import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, CalendarDays, Users, MapPin, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import axios, { API } from "@/lib/api";

function formatDate(d) {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
}

export default function ProgramsPreview() {
  const [programs, setPrograms] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/public/programs`).then(({ data }) => setPrograms(data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-testid="programs-section">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Program Unggulan</span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-[#1F2937] sm:text-4xl">Pilihan Program Haji &amp; Umrah</h2>
        </div>
        <Button variant="outline" data-testid="programs-view-all-button" onClick={() => navigate("/program")} className="gap-2 rounded-full">
          Lihat Semua Program <ArrowRight className="h-4 w-4" />
        </Button>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
        {programs.map((p) => (
          <div key={p.id} data-testid={`program-card-${p.id}`} className="overflow-hidden rounded-2xl bg-white shadow-[0_2px_16px_rgba(15,107,79,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(15,107,79,0.14)]">
            <div className="relative h-48">
              <img src={p.cover_image} alt={p.name} className="h-full w-full object-cover" />
              <Badge className="absolute left-3 top-3 rounded-full bg-white/95 text-[#0F6B4F] capitalize">{p.type}</Badge>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-lg font-semibold text-[#1F2937] line-clamp-1">{p.name}</h3>
              <div className="mt-3 space-y-1.5 text-sm text-[#64748B]">
                <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4" /> {formatDate(p.departure_date)}</p>
                <p className="flex items-center gap-2"><Users className="h-4 w-4" /> Sisa Kuota: {Math.max(p.quota - p.quota_taken, 0)}</p>
                <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {p.duration_days} Hari</p>
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-4">
                <p className="flex items-center gap-1.5 text-xs font-semibold text-[#92720C]"><Sparkles className="h-3.5 w-3.5" /> Info Harga via Admin</p>
                <Button size="sm" data-testid={`program-detail-button-${p.id}`} onClick={() => navigate(`/program/${p.slug}`)} className="rounded-full bg-[#0F6B4F] text-white hover:bg-[#084C3A]">
                  Lihat Detail
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
